import { render } from "./IconCircleContainer.vue?vue&type=template&id=87d93a9c&scoped=true"
import script from "./IconCircleContainer.vue?vue&type=script&lang=js"
export * from "./IconCircleContainer.vue?vue&type=script&lang=js"

import "./IconCircleContainer.vue?vue&type=style&index=0&id=87d93a9c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87d93a9c"]])

export default __exports__